
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"
// import { User } from "~/types/acl"

// noinspection JSUnusedGlobalSymbols
export default defineComponent({
    name: "ListPage",
    components: { AclLayout },
    props: {
        users: {
            // type: Object as PropType<User>,
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    methods: {
        /* deleteUser(user: User) {
            if (!user) return
            if (confirm('Вы действительно хотите удалить пользователя "' + user.name + '"'))
                this.$inertia.delete("/acl/users/" + user.id)
        }, */
    },
})
